import { serviceRouteConstants } from "@/Constants/routingConstants";

import { post } from ".";
import store from "../store";

/**
 * Fetch rate using a POST request- 1st step of creating a job.
 */
export const _fetchRate = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.listOfRate,
    data: data,
  };
  return await post(request);
};

export const _fetchClientMultipleRates = async (data) => {
  const request = {
    endPoint: serviceRouteConstants?.multipleListOfClientRate,
    data: data,
  };
  return await post(request);
};
/**
 * Fetches skills using the provided data.
 *
 * @param {object} data - The data to be used for fetching skills.
 * @return {Promise} The result of the post request.
 */
export const _fetchSkills = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.fieldData,
    data: data,
  };
  return await post(request);
};

/**
 * Fetches day-wise rates from the server.
 *
 * @param {Object} data - The data to be sent in the request.
 * @return {Promise} The response from the server.
 */
export const _fetchDayWiseRates = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.dayWiseRate,
    data: data,
  };
  return await post(request);
};

/**
 * Creates a job using the provided data.
 *
 * @param {object} data - The data used to create the job
 * @return {Promise} The result of the job creation
 */
export const _createJob = async (data, postjobClient) => {
  // 	$adminChargePercent 		= $request->input('admin_per');
  // 	$visitChargePercent 		= $request->input('visit_per');
  // 	$totalAdminCharge 			= $request->input('totalAdminCharge');
  // 	$pricePerVisit 				= $request->input('price_per_visit');
  // 	$clientRateId 				= $request->input('client_rate_id');
  // 	$totalHour 					= $request->input('totalHours');
  // 	$vat_structure 				= $request->input('vatStructure');
  // 	$totalCost 					= $request->input('totalCost');
  // 	$dayRate 					= $request->input('dayRate');
  // 	$negotiateTime 				= $request->input('negotiateTime');
  // 	$negotiateRate 				= $request->input('negotiateRate');
  // 	$allSubContracts 			= $request->input('all_sub_contracts');
  // 	$setAsTemplate 				= $request->input('setAsTemplate');

  // 	if(count($allSubContracts) > 0){
  // 		$allSubContracts = json_encode($allSubContracts);
  // 	}

  // 	if(!empty($primarySpeciality)){
  // 		$primarySpeciality = implode(',', $primarySpeciality);
  // 	}
  // 	$perWeekDay = implode(',', $perWeekDay);

  // 	$headers = ApiHelper::getHeaders();
  // 	$postData = array(
  // 	'job_title'							=> $jobTitle,
  // 	'description'						=> $jobDescription,
  // 	'role_id'							=> $sessionType,
  // 	'grade_id'							=> $sessionTypeChild,
  // 	'primary_speciality'				=> $primarySpeciality,
  // 	'start_date'						=> $startDate,
  // 	'end_date'							=> $endDate,
  // 	'start_time'						=> $startTime,
  // 	'end_time'							=> $endTime,
  // 	'per_week_day'						=> $perWeekDay,
  // 	'break_time'						=> $breakTime,
  // 	'no_of_visit'						=> $noOfVisit,
  // 	'admin_time' 						=> $adminTime,
  // 	'admin_charge_percent'				=> $adminChargePercent,
  // 	'visit_charge_percent' 				=> $visitChargePercent,
  // 	'total_admin_charge' 				=> $totalAdminCharge,
  // 	'price_per_visit' 					=> $pricePerVisit,
  // 	'client_rate_id'					=> $clientRateId,
  // 	'total_hour'						=> $totalHour,
  // 	'vat_structure'						=> $vat_structure,
  // 	'total_cost'						=> $totalCost,
  // 	'day_rate'							=> $dayRate,
  // 	'negotiate_time'					=> $negotiateTime,
  // 	'negotiate_rate' 					=> $negotiateRate,
  // 	'all_sub_contracts' 				=> $allSubContracts,
  // 	'save_as_template' 					=> $setAsTemplate,
  // 	);

  // console.log("store.getState().clientCandidatesInvited.selectedCandidateIds.join(", ")", store.getState().clientCandidatesInvited.selectedCandidateIds.join(","))

  let jobtitle = data.jobTitle;
  let jobDescription = data.jobDescription;
  let sessionType = data.parentID;
  let sessionTypeChild = data.roleId;
  let primarySpeciality = data.skills;
  let startDate = data.startDate;
  let endDate = data.endDate;
  let startTime = data.startTime;
  let endTime = data.endTime;
  let perWeekDay = data.weekDays;
  let breakTime = data.breakTime;
  let noOfVisit = data.noOfVisit;
  let adminTime = data.adminTime;
  let adminChargePercent = data.admin_per;
  let visitChargePercent = data.visit_per;
  let totalAdminCharge = data.totalAdminCharge || 0;
  let pricePerVisit = data.price_per_visit || "";
  let clientRateId = data.client_rate_id;
  let totalHour = data.totalHours;
  let vat_structure = data.vatStructure;
  let totalCost = data.totalCost;
  let dayRate = data.dayRate;
  let negotiateTime = data.negotiateTime;
  let negotiateRate = data.negotiateRate;
  let allSubContracts = data.all_sub_contracts;
  let setAsTemplate = data.setAsTemplate;
  let is_for_appLocum_candidates = store.getState().clientProfile.user
    .is_bank_client
    ? data.is_for_appLocum_candidates
      ? 1
      : 0
    : 1;
  let is_book_candidate = store.getState().clientCreateJob.selectedCandidateIds
    .length
    ? 1
    : 0;
  let book_candidate_id =
    store.getState().clientCreateJob.selectedCandidateIds.join(",") || "";

  let custom_template_id = data?.custom_template_id;
  let generic_template_id = data?.generic_template_id;

  if (allSubContracts.length > 0) {
    allSubContracts = JSON.stringify(allSubContracts);
  }

  if (primarySpeciality.length > 0) {
    primarySpeciality = primarySpeciality.join(",");
  }

  perWeekDay = perWeekDay.join(",");

  let postData = {
    job_title: jobtitle,
    description: jobDescription,
    role_id: sessionType,
    grade_id: sessionTypeChild,
    primary_speciality: primarySpeciality,
    start_date: startDate,
    end_date: endDate,
    start_time: startTime,
    end_time: endTime,
    per_week_day: perWeekDay,
    break_time: breakTime,
    no_of_visit: noOfVisit,
    admin_time: adminTime,
    admin_charge_percent: adminChargePercent || "",
    visit_charge_percent: visitChargePercent || "",
    total_admin_charge: totalAdminCharge,
    price_per_visit: pricePerVisit,
    client_rate_id: clientRateId,
    total_hour: totalHour,
    vat_structure: vat_structure,
    total_cost: totalCost,
    is_day_rate: dayRate,
    negotiate_time: negotiateTime,
    negotiate_rate: negotiateRate,
    all_sub_contracts: allSubContracts,
    save_as_template: setAsTemplate ? 1 : 0,
    is_for_appLocum_candidates: is_for_appLocum_candidates,
    is_book_candidate: is_book_candidate,
    book_candidate_id: book_candidate_id,
    custom_template_id: setAsTemplate ? custom_template_id : "",
    generic_template_id: setAsTemplate ? generic_template_id : "",
  };

  const request = {
    endPoint: serviceRouteConstants.saveCreateJob,
    data: postData,
  };
  return await post(request);
};

export const _deleteJobTemplate = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.deleteJobTemplate,
    data: data,
  };
  return await post(request);
};

export const _fetchJobTemplates = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.jobTemplates,
    data: data,
  };
  return await post(request);
};

export const _fetchBankShortListCandidate = async (data) => {
  const user = store.getState().clientProfile.user;
  const session = store.getState()?.session?.session;
  const checkEndpoint = serviceRouteConstants?.fetchBankShortListCandidate;

  const request = {
    endPoint: checkEndpoint,
    data: data,
  };
  return await post(request);
};
